<template>
  <v-page white>
    <product-template :product-ids="productIds" />
  </v-page>
</template>

<script>
export default {
  components: {
    ProductTemplate: () => import("@/components/page-templates/ProductTemplate")
  },

  computed: {
    productIds() {
      return this.$route.params.ids?.split(",") || []
    }
  }
}
</script>
